{
  "siteUrl": "https://www.purchasedonpremises.com"
}
